import React, { Fragment } from "react";

import * as R from "ramda";

import Locator from "src/locator";
import LiveChat from "src/chat";

import camelCase from "camel-case";

import AppointmentForm from "../forms/AppointmentForm";
import MemberServicesForm from "../forms/MemberServicesForm";
import AppointmentCampaignForm from "../forms/AppointmentCampaignForm";
import ContactForm from "../forms/ContactForm";
import DirectDepositForm from "../forms/DirectDepositForm";
import EventRSVPForm from "../forms/EventRSVPForm";
import FeedbackForm from "../forms/FeedbackForm";
import LoanApplicationForm from "../forms/LoanApplicationForm";
import ScholarshipForm from "../forms/ScholarshipForm";
import WebsiteFeedbackForm from "../forms/WebsiteFeedbackForm";
import HereToHelpForm from "../forms/HereToHelpForm";
import BallStateForm from "../forms/BallStateForm";
import ShortContactForm from "../forms/ShortContact";

import { Box, Markup } from "src/components";

import Eventbrite from "./Eventbrite";
import Wistia from "./Wistia";
import ArticleArchive from "./ArticleArchive";
import BrokerCheck from "./BrokerCheck";

const withLayout = WrappedComponent => ({ header, ...props }) => (
  <Box py={2} px={[3, 3, 4]}>
    <Markup html={R.path(["childMarkdownRemark", "html"], header)} />
    <WrappedComponent {...props} />
  </Box>
);

const moduleComponents = {
  locator: Locator,
  appointmentForm: withLayout(AppointmentForm),
  memberServicesForm: withLayout(MemberServicesForm),
  appointmentCampaignForm: withLayout(AppointmentCampaignForm),
  articleArchive: withLayout(ArticleArchive),
  contactForm: withLayout(ContactForm),
  directDepositForm: withLayout(DirectDepositForm),
  feedbackForm: withLayout(FeedbackForm),
  scholarshipForm: withLayout(ScholarshipForm),
  loanApplicationForm: withLayout(LoanApplicationForm),
  websiteFeedbackForm: withLayout(WebsiteFeedbackForm),
  hereToHelpForm: withLayout(HereToHelpForm),
  eventRsvp: withLayout(EventRSVPForm),
  ballstateForm: withLayout(BallStateForm),
  shortContactForm: withLayout(ShortContactForm),
  eventbrite: Eventbrite,
  wistia: Wistia,
  liveChat: props => (
    <Box py={2} px={[3, 3, 4]}>
      <LiveChat {...props} />
    </Box>
  ),
  brokerCheck: BrokerCheck,
};

const Module = ({ options, moduleKey, pageData, siteData, header }) => {
  if (!moduleKey) {
    return null;
  }

  const ModuleComponent = moduleComponents[camelCase(moduleKey)];

  return ModuleComponent ? (
    <ModuleComponent
      options={options}
      moduleKey={moduleKey}
      header={header}
      siteData={siteData}
      pageData={pageData}
    />
  ) : null;
};

export default Module;

export const moduleFragment = graphql`
  fragment Module on ContentfulModule {
    id
    __typename
    moduleKey: key
    options {
      apiKey
      defaultLocation {
        zoom
        latitude
        longitude
      }
      formKey
      options {
        value
        label
        label_es
      }
      branchOptions {
        value
        label
        label_es
      }
      locationOptions {
        value
        label
        label_es
      }
      chatUrl
      eventId
      videoId
      loanTypes {
        value
        label
      }
    }
    header {
      childMarkdownRemark {
        html
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Content/Module/Module.js